<template>
  <div
    class="modal fade dq-modal"
    id="loan_settle_confirm_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-body dq-status-body">
          <div class="dq-status-hero">
            <span class="dq-status-badge dq-status-badge-ok">
              <i class="ti ti-cash"></i>
            </span>
          </div>

          <h4 class="mb-2 dq-status-title">Settle on next payroll</h4>
          <p class="mb-0 dq-status-subtitle">
            Set the loan installment to the full payoff for
            <b>{{ breakdown?.period || "—" }}</b>. Run payroll as usual to deduct and close the loan.
          </p>

          <div v-if="breakdown" class="dq-settle-summary mt-3 text-start">
            <div class="d-flex justify-content-between small">
              <span class="text-muted">Opening balance</span>
              <span>{{ money(breakdown.opening_balance) }}</span>
            </div>
            <div class="d-flex justify-content-between small mt-1">
              <span class="text-muted">Interest this period</span>
              <span>{{ money(breakdown.interest_amount) }}</span>
            </div>
            <div class="d-flex justify-content-between fw-semibold mt-2 pt-2 border-top">
              <span>Payroll deduction</span>
              <span>{{ money(breakdown.total_installment) }}</span>
            </div>
          </div>

          <div class="d-flex justify-content-center flex-wrap gap-2 mt-4">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="submitting">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="submitting || !breakdown"
              @click="confirm"
            >
              <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
              Confirm settlement
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Modal } from "bootstrap";

const emit = defineEmits(["confirmed"]);

const submitting = ref(false);
const breakdown = ref(null);
const loanId = ref(null);
const currency = ref("KES");

let modal;

function money(amount) {
  return `${currency.value} ${Number(amount ?? 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function open({ id, preview, currencyCode = "KES" }) {
  loanId.value = id;
  breakdown.value = preview?.breakdown || preview || null;
  currency.value = currencyCode;
  if (!modal) {
    modal = new Modal(document.getElementById("loan_settle_confirm_modal"), {
      backdrop: false,
    });
  }
  modal.show();
}

function hide() {
  modal?.hide();
}

function setSubmitting(value) {
  submitting.value = value;
}

function confirm() {
  if (!loanId.value || !breakdown.value) return;
  emit("confirmed", {
    loanId: loanId.value,
    period: breakdown.value.period,
  });
}

defineExpose({ open, hide, setSubmitting });
</script>

<style scoped>
.dq-status-body {
  padding: 1.75rem 1.5rem 1.5rem;
  text-align: center;
}
.dq-status-hero {
  display: flex;
  justify-content: center;
  margin-bottom: 0.75rem;
}
.dq-status-badge {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}
.dq-status-badge-ok {
  background: rgba(34, 197, 94, 0.12);
  color: #16a34a;
}
.dq-status-title {
  font-size: 1.15rem;
  font-weight: 700;
}
.dq-status-subtitle {
  color: rgba(15, 23, 42, 0.65);
  font-size: 0.92rem;
}
.dq-settle-summary {
  background: rgba(15, 23, 42, 0.04);
  border-radius: 12px;
  padding: 12px 14px;
}
</style>
